module.exports = __webpack_public_path__ + "img/poziom9.c946b5f1.svg";